import { render, staticRenderFns } from "./PresStoriesTagsPopup.vue?vue&type=template&id=16409d02&scoped=true"
import script from "./PresStoriesTagsPopup.vue?vue&type=script&lang=js"
export * from "./PresStoriesTagsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16409d02",
  null
  
)

export default component.exports